import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import styles from './UserInfo.scss';
import { SWITCH_WITH_CLIENT } from 'constants/ActionTypes';
import { USER_ROLE, TARIFFS } from 'constants';
import { getUserRole, getTarifName } from 'utils';
import Checkbox from 'components/common/Checkbox';

import iconClient from 'assets/images/icons/user-dropdown-client-mode.svg';
import iconProfile from 'assets/images/icons/user-dropdown-profile.svg';
import iconProfileCompany from 'assets/images/icons/user-dropdown-company-profile.svg';
import iconExit from 'assets/images/icons/user-dropdown-exit.svg';
import tracker from '../../../../services/tracker';
import { withTranslation } from 'react-i18next';

class UserInfo extends Component {

  handleClientModeClick = () => {
    tracker.sendEvent('Web_Profile_With_Client', {
      selected: !this.props.privacy.withClient
    });
    this.props.dispatch({ type: SWITCH_WITH_CLIENT });
  }

	/* FIXME: move to react-intl */
  getNumEnding(iNumber, aEndings) {
    let sEnding,
      i;
    iNumber %= 100;
    if (iNumber >= 11 && iNumber <= 19) {
      sEnding = aEndings[2];
    }		else {
      i = iNumber % 10;
      switch (i)			{
        case (1): sEnding = aEndings[0]; break;
        case (2):
        case (3):
        case (4): sEnding = aEndings[1]; break;
        default: sEnding = aEndings[2];
      }
    }
    return sEnding;
  }

  getUserTarifTab() {
    const { profile, t } = this.props;

    if (profile.tariff) {
      const role = getUserRole(profile);
      const tarif = getTarifName(profile.tariff.pricing);
      return (
        <div className={styles.TarifBlock}>
          <div className={styles.TarifName}>
            {role === USER_ROLE.WORKER ? <div>{profile.agencyName}</div> : <div>
              {t('components.header.user.tarif', { tarif })}
            </div>}
          </div>
          <div className={cn(styles.TarifTime, { [styles.Red]: (profile.tariff.countDay < 6) })}>{profile.tariff.countDay} {this.getNumEnding(profile.tariff.countDay, [t('components.header.user.day1'), t('components.header.user.day2'), t('components.header.user.day3')])}</div>
        </div>
      );
    }
    return null;
  }

  render() {
    const { isBlocked, t } = this.props;
    return (
      <div className={cn(styles.UserInfo)}>
        <div>
          <div>
            {this.getUserTarifTab()}
          </div>
          {!isBlocked && <div className={cn(styles.Link, { [styles.Active]: this.props.privacy.withClient })} onClick={this.handleClientModeClick}>
            <img src={iconClient} className={styles.LinkImage} alt={t('components.header.user.withClient')} />
            <span className={styles.LinkText}>
              {t('components.header.user.withClient')}
              <span className={cn(styles.ClientModeSwitcher, { [styles.Enabled]: this.props.privacy.withClient })}>
                <span className={styles.Marker}></span>
              </span>
              {/* <Checkbox */}
              {/* className={styles.Checkbox} */}
              {/* innerStyle={styles.CheckboxInner} */}
              {/* checked={this.props.privacy.withClient} */}
              {/* /> */}
            </span>
          </div>}
          <Link onClick={() => tracker.sendEvent(this.props.roleName === 'owner' ? 'Web_My_Profile' : 'Web_Profile')} className={styles.Link} to="/profile">
            <img src={iconProfile} className={styles.LinkImage} alt={t('components.header.user.profile')} />
            <span className={styles.LinkText}>
              {this.props.roleName === 'owner' ? t('components.header.user.myProfile') : t('components.header.user.profile')}
            </span>
          </Link>
          {
						this.props.roleName === 'owner' &&
						<Link onClick={() => tracker.sendEvent('Web_Profile_Company')} className={styles.Link} to="/company">
  <img src={iconProfileCompany} className={styles.LinkImage} alt={t('components.header.user.companyProfile')} />
  <span className={styles.LinkText}>
    {t('components.header.user.companyProfile')}
  </span>
						</Link>
					}
          <Link className={styles.Link} to="/logout">
            <img src={iconExit} className={styles.LinkImage} alt={t('components.header.user.logout')} />
            <span className={styles.LinkText}>
              {t('components.header.user.logout')}
            </span>
          </Link>
        </div>
        <div className={styles.Arrow} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  privacy: state.privacy,
  profile: state.profile
});

export default connect(mapStateToProps)(withTranslation()(UserInfo));



// WEBPACK FOOTER //
// ./src/components/Header/User/UserInfo/UserInfo.js